module.exports = __webpack_public_path__ + "static/media/art-antique.7307c86f.jpg";